export default "__VITE_ASSET__DAgPlmN$__"